const FALLBACK_LOCALE = "en-US";
/** Every value in the grid (counts, ratios and percentages) shows 2 decimals. */
const DISPLAY_DECIMALS = 2;

/** App locales such as "en-US-cxone" / "en-US-Dummy" are not BCP-47; reduce them to a locale Intl accepts. */
export function toIntlLocale(appLocale: string | null | undefined): string {
  if (!appLocale) {
    return FALLBACK_LOCALE;
  }
  const candidate = appLocale.replace(/-(cxone|dummy)$/i, "");
  try {
    return Intl.getCanonicalLocales(candidate)[0] ?? FALLBACK_LOCALE;
  } catch {
    return FALLBACK_LOCALE;
  }
}

export function formatCount(value: number, locale: string): string {
  return new Intl.NumberFormat(locale, {minimumFractionDigits: DISPLAY_DECIMALS, maximumFractionDigits: DISPLAY_DECIMALS}).format(value);
}

export function formatPercent(value: number, locale: string): string {
  return new Intl.NumberFormat(locale, {style: "percent", minimumFractionDigits: DISPLAY_DECIMALS, maximumFractionDigits: DISPLAY_DECIMALS}).format(value / 100);
}

/**
 * Cuts the digits after {@code decimals} toward zero, as Plan Detail's and Staffing Distribution's "floor" does; the cut is made on
 * the text of the number, so a value such as 0.29 does not drift through a multiplication.
 */
export function truncateDecimals(value: number, decimals = 2): number {
  if (!Number.isFinite(value)) {
    return value;
  }
  const text = value.toString();
  if (text.includes("e")) {
    const factor = 10 ** decimals;
    return Math.trunc(value * factor) / factor + 0;
  }
  const dot = text.indexOf(".");
  return dot < 0 ? value : Number(text.slice(0, dot + 1 + decimals));
}
